// Frontend mirror of the backend RBAC contract (packages/backend/src/plugins/
// rbac/permissions.ts + storage/types.ts). Kept in sync manually — these are
// the wire shapes returned by GET /me and the /users endpoints.

export type RbacRole = 'user' | 'admin' | 'super_admin';

export type UserStatus = 'active' | 'disabled';

export type RbacPermission =
  | 'vm.create'
  | 'vm.read.own'
  | 'vm.read.all'
  | 'vm.lifecycle.own'
  | 'vm.lifecycle.all'
  | 'request.read.own'
  | 'request.read.all'
  | 'request.approve.assigned'
  | 'request.approve.all'
  | 'approvalHistory.own'
  | 'approvalHistory.all'
  | 'user.manage'
  // Not granted by any role by default — only ever held via an explicit
  // per-user grant (or the super_admin wildcard). See
  // AssignPermissionsDialog / PATCH /users/:id/permissions.
  | 'vm.import'
  // Super admin only (via the wildcard): VM Governance dashboard.
  | 'vm.governance';

export interface Me {
  email: string;
  displayName: string;
  role: RbacRole;
  status: UserStatus;
  permissions: RbacPermission[];
}

export interface RbacUser {
  id: string;
  email: string;
  entityRef: string;
  displayName: string;
  role: RbacRole;
  status: UserStatus;
  /** Free-text team/group label — admin-assigned via "Add User" or the
   * Team column's Edit action, never set by the sign-in upsert. */
  team?: string;
  createdAt: string;
  updatedAt: string;
  lastLoginAt?: string;
}

export interface AuditLogEntry {
  id: string;
  actorEmail: string;
  action: string;
  target?: string;
  before?: unknown;
  after?: unknown;
  createdAt: string;
}

export const ROLE_LABELS: Record<RbacRole, string> = {
  user: 'User',
  admin: 'Admin',
  super_admin: 'Super Admin',
};
